import * as $            from 'jquery';
import { $body }         from 'Core/Body';
import { Notifications } from 'Core/Notifications';
import { ReCaptcha }     from 'Core/ReCaptcha';
import InvoiceFields     from '../Fields/InvoiceFields';

export default class InvoiceFormValidation {
    readonly Selector: any;
    readonly view: string;

    constructor() {
        this.validate = this.validate.bind(this);
        this.Selector = {
            FORM: '#invoiceForm',
        };

        let link = $(this.Selector.FORM).attr('action')

        link = link ? link.replace('action', '') : '';

        let param = link.split('/');

        if (param.length >= 4 && param[4] === 'send') {
            this.view = $(this.Selector.FORM).attr('action').split('/')[4];
        } else {
            this.view = undefined;
        }
    }

    public validate() {
        let rules = InvoiceFields.getFields(this.Selector);
        

        if (this.view === 'send') {
            Object.assign(rules, {
                agree_rules:             { required: true },
                invoice_change_content:  { required: true },
            });
        }

        $(this.Selector.FORM).validate({
            ignore: '',
            rules: rules,
        });
    }

    public onLoad() {
        $(window).on('load', this.validate);
    }

    public onChange() {
        $(window).on('change', this.validate);
    }

    public submit() {
        $(this.Selector.FORM).on('submit', (e) => {

            // let recaptcha = ($('#g-recaptcha-response').val());
            //
            // if (this.view === 'send' && $(this.Selector.FORM).valid()) {
            //     if (recaptcha != 'true') {
            //         Notifications.add('Pole reCaptcha jest nieprawidłowe', 'error');
            //         e.preventDefault();
            //     }
            // }
        });
    }

    public createRecaptcha() {
        let recaptcha = new ReCaptcha();

        let sitekey = $('#g-recaptcha').attr('data-sitekey');

        $body.ready(() => {
            recaptcha.render(sitekey, 'g-recaptcha');
        });
    }
}
import * as $            from 'jquery';
import { $body }         from 'Core/Body';
import { Notifications } from 'Core/Notifications';
import { ReCaptcha }     from 'Core/ReCaptcha';
import InvoiceFields     from '../Fields/InvoiceFields';

export default class InvoiceFormValidation {
    readonly Selector: any;
    readonly view: string;

    constructor() {
        this.validate = this.validate.bind(this);
        this.Selector = {
            FORM: '#invoiceForm',
        };

        let link = $(this.Selector.FORM).attr('action')

        link = link ? link.replace('action', '') : '';

        let param = link.split('/');

        if (param.length >= 4 && param[4] === 'send') {
            this.view = $(this.Selector.FORM).attr('action').split('/')[4];
        } else {
            this.view = undefined;
        }
    }

    public validate() {
        let rules = InvoiceFields.getFields(this.Selector);
        

        if (this.view === 'send') {
            Object.assign(rules, {
                agree_rules:             { required: true },
                invoice_change_content:  { required: true },
            });
        }

        $(this.Selector.FORM).validate({
            ignore: '',
            rules: rules,
        });
    }

    public onLoad() {
        $(window).on('load', this.validate);
    }

    public onChange() {
        $(window).on('change', this.validate);
    }

    public submit() {
        $(this.Selector.FORM).on('submit', (e) => {

            // let recaptcha = ($('#g-recaptcha-response').val());
            //
            // if (this.view === 'send' && $(this.Selector.FORM).valid()) {
            //     if (recaptcha != 'true') {
            //         Notifications.add('Pole reCaptcha jest nieprawidłowe', 'error');
            //         e.preventDefault();
            //     }
            // }
        });
    }

    public createRecaptcha() {
        let recaptcha = new ReCaptcha();

        let sitekey = $('#g-recaptcha').attr('data-sitekey');

        $body.ready(() => {
            recaptcha.render(sitekey, 'g-recaptcha');
        });
    }
}
